<template>
  <b-card>
    <b-card-header>
      <h3>Tabletop supplements under development</h3>
    </b-card-header>
    <b-card-body>
      <b-list-group>
        <b-list-group-item>
          Road to Redemption
          <em>(Firefly RPG five adventure series)</em>
        </b-list-group-item>
        <b-list-group-item>
          Tai'mar
          <em>(Setting Soucebook)</em>
        </b-list-group-item>
        <b-list-group-item>
          The Hidden Heir
          <em>(D&amp;D 5E Setting and Campaign)</em>
        </b-list-group-item>
        <b-list-group-item>
          The Wizarding World of Fate
          <em>(Fate Core/Acclerated Setting)</em>
        </b-list-group-item>
      </b-list-group>
    </b-card-body>
    <b-card-footer>
      <p>
        Interested in joining the volunteer testing team? <a href="https://forms.gle/UC1wisjPUXeuaBV39" target="_blank">Click here</a>
      </p>
    </b-card-footer>
  </b-card>
</template>

<script>
export default {
  name: "HomeView",
  data() {
    return {
      message: "Coming Soon!"
    };
  }
};
</script>

<style scoped>
div.underDev {
  width: 85%;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
}
div.underDev h3 {
  font-weight: bold;
}
div.underDev ul {
  list-style: disc;
}
</style>
